import { createReducer } from '../../app/common/util/reducerUtil';
import { GET_BANKS, ACCOUNT_ADDED, ACCOUNT_UPDATED, GENERATE_OTP_BANK, SELECT_ACCOUNT } from './accountConstants';

const initialState = {};

export const getBanks = (state, payload) => {
  return {
    ...state,
    get: payload,
  }
};

export const accountAdded = (state, payload) => {
  return {
    ...state,
    added: payload,
  }
};

export const accountUpdated = (state, payload) => {
  return {
    ...state,
    updated: payload,
  }
};

export const selectAccount = (state, payload) => {
  return {
    ...state,
    select: payload,
  }
};

export const generateOTP = (state, payload) => {
  return {
    ...state,
    otp: payload,
  }
};

export default createReducer(initialState, {
  [GET_BANKS]: getBanks,
  [ACCOUNT_ADDED]: accountAdded,
  [ACCOUNT_UPDATED]: accountUpdated,
  [SELECT_ACCOUNT]: selectAccount,
  [GENERATE_OTP_BANK]: generateOTP,
});